import Api from './api';

export const getMural = async (page = 1, size = 10) =>
  await Api.get(`/announcements/mural?page=${page}&size=${size}`);

export const getMuralItem = async (id) => await Api.get(`/announcements/mural/${id}`);

export const getUnreadCount = async () => await Api.get('/announcements/unread-count');

export const paginateManage = async (page = 1, size = 10, field = '', search = '') => {
  let url = `/announcements/manage/paginate?page=${page}&size=${size}`;
  if (field && field.length > 0) url += `&field=${encodeURIComponent(field)}`;
  if (search && search.length > 0) url += `&search=${encodeURIComponent(search)}`;
  return await Api.get(url);
};

export const getById = async (id) => await Api.get(`/announcements/${id}`);

const buildFormData = (payload) => {
  const fd = new FormData();
  fd.append('Title', payload.title != null ? payload.title : '');
  fd.append('Content', payload.content != null ? payload.content : '');
  fd.append('TypeId', payload.typeId != null ? payload.typeId : 1);
  fd.append('AudienceId', payload.audienceId != null ? payload.audienceId : 1);
  fd.append('Pinned', payload.pinned ? 'true' : 'false');
  fd.append('RequireAcknowledgment', payload.requireAcknowledgment ? 'true' : 'false');
  if (payload.publishDate) fd.append('PublishDate', payload.publishDate);
  if (payload.closeDate) fd.append('CloseDate', payload.closeDate);
  fd.append('AllOrganizations', payload.allOrganizations ? 'true' : 'false');
  (payload.organizationIds || []).forEach((id) => fd.append('OrganizationIds', id));
  (payload.keepAttachmentIds || []).forEach((id) => fd.append('KeepAttachmentIds', id));
  (payload.files || []).forEach((f) => fd.append('Attachments', f));
  return fd;
};

export const create = async (payload) =>
  await Api.post('/announcements', buildFormData(payload), { headers: { 'Content-Type': 'multipart/form-data' } });

export const update = async (id, payload) =>
  await Api.put(`/announcements/${id}`, buildFormData(payload), { headers: { 'Content-Type': 'multipart/form-data' } });

export const remove = async (id) => await Api.delete(`/announcements/${id}`);
export const archive = async (id) => await Api.put(`/announcements/${id}/archive`);
export const closeItem = async (id) => await Api.put(`/announcements/${id}/close`);
export const reactivate = async (id) => await Api.put(`/announcements/${id}/reactivate`);

export const getSettings = async () => await Api.get('/announcements/settings');
export const updateSettings = async (payload) => await Api.put('/announcements/settings', payload);

export const getTargetableOrganizations = async () => await Api.get('/announcements/organizations');
